import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, ArrowUpRight } from "lucide-react";
import { CONTACT, NAV_LINKS } from "@/data/site";
import { Logo } from "./Header";

const AREAS = ["NSW", "Queensland", "Victoria", "ACT", "Nationwide Australia"];

export default function Footer() {
  return (
    <footer className="bg-navy text-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 pb-10 pt-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Logo light />
            <p className="mt-6 font-heading text-xl font-bold text-gold">
              Construction Workforce. Built for Performance.
            </p>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-white/60">
              Professional labour hire and workforce solutions for Australia's construction industry.
            </p>
            <div className="mt-8 space-y-3 text-sm text-white/70">
              <p className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
                <span>{CONTACT.address1}, {CONTACT.address2}</span>
              </p>
              <a href={CONTACT.phoneHref} data-testid="footer-phone-link" className="flex items-center gap-3 transition-colors hover:text-gold">
                <Phone className="h-4 w-4 shrink-0 text-gold" />
                {CONTACT.phone}
              </a>
              <a href={CONTACT.emailHref} data-testid="footer-email-link" className="flex items-center gap-3 transition-colors hover:text-gold">
                <Mail className="h-4 w-4 shrink-0 text-gold" />
                {CONTACT.email}
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <h3 className="text-xs font-semibold uppercase tracking-[0.3em] text-white/40">Quick Links</h3>
            <ul className="mt-5 space-y-2.5">
              {NAV_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    className="text-sm text-white/70 transition-colors hover:text-gold"
                  >
                    {link.label === "Home" ? "Home" : link.label === "About" ? "About Formcore" : link.label === "Services" ? "Services" : link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h3 className="text-xs font-semibold uppercase tracking-[0.3em] text-white/40">Service Areas</h3>
            <ul className="mt-5 space-y-2.5">
              {AREAS.map((area) => (
                <li key={area} className="text-sm text-white/70">{area}</li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h3 className="text-xs font-semibold uppercase tracking-[0.3em] text-white/40">Start a Conversation</h3>
            <Link
              to="/contact"
              data-testid="footer-request-workforce-btn"
              className="mt-5 inline-flex items-center gap-2 bg-gold px-5 py-3 font-heading text-xs font-bold uppercase tracking-[0.12em] text-navy transition-colors hover:bg-gold-dark"
            >
              Request Workforce
              <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-xs text-white/40 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} Formcore Constructions. All rights reserved.</p>
          <p className="flex items-center gap-5">
            <Link to="/privacy" data-testid="footer-privacy-link" className="transition-colors hover:text-gold">Privacy Policy</Link>
            <span className="h-3 w-px bg-white/20" />
            <Link to="/terms" data-testid="footer-terms-link" className="transition-colors hover:text-gold">Terms & Conditions</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
